// extracted by mini-css-extract-plugin
export default {"logoLink":"Logo_logoLink__oJ4LX","logoSvg":"Logo_logoSvg__woQ6q"};